import Image from "next/image";
import Link from "next/link";
import { styled } from "styled-components";
import { useGlobalContext } from "@/lib/globalContext";
import { variables } from "oddsgate-ds";

export const StyledLogo = styled.div`
  width: 8rem;

  @media only screen and (min-width: ${variables.responsiveMedia}) {
    width: 15rem;
  }
`;

const Logo = () => {
  const state = useGlobalContext();
  const defaultLang = process.env.NEXT_PUBLIC_DEFAULT_LANG || 'en';
  const currentLang = state.lang || defaultLang;
  
  // Default lang goes to /, other langs go to /pt/, /es/, etc.
  const homeUrl = currentLang === defaultLang ? '/' : `/${currentLang}/`;

  return (
    <StyledLogo>
      <Link href={homeUrl}>
        <Image
          src={"/assets/logo.svg"}
          alt={process.env.NEXT_PUBLIC_SITE_NAME as string}
          width={217}
          height={37}
          priority={true}
          unoptimized
        />
      </Link>
    </StyledLogo>
  );
};
export default Logo;
